import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
/* eslint-disable */
const $ = jQuery.noConflict();
const megaMenuWrapper = document.querySelectorAll('.mega-menu-wrapper');
const mediaQueryXl = window.matchMedia('screen and (min-width: 1200px)');

/**
 * In MobileHeader class is needed to avoid links inside .mega-menu-wrapper (and those links have to  be clickable)
 * Thats why we need add for those links custom class and with that class we can select all links that are inside mega mneu wrapper
 */
const grabMobileMenuMegaLinks = () => {
	const mobileNavigationLink = document.querySelectorAll(
		'.main-header__nav-mobile .mega-menu-wrapper .menu li'
	);

	if (!mobileNavigationLink) {
		return;
	}

	mobileNavigationLink.forEach((link) => {
		if (link) {
			link.classList.add('mobile-navigation-link');
		}
	});
};
/**
 * We need to fire this function before MobileHeader classs will run, so thats why we need to fire this function here
 * Also its easier to localize
 */
grabMobileMenuMegaLinks();
class MobileHeader {
	constructor(
		trigger = '.btn-hamburger',
		pbody = 'body',
		listParent = '.main-header__nav-mobile .menu-item:not(.mobile-navigation-link) > a'
	) {
		this.trigger = trigger;
		this.pbody = pbody;
		this.listParent = listParent;
		this.menuItemsWithChildren = document.querySelectorAll(
			'.main-header__nav-mobile .menu > .menu-item:not(.mobile-navigation-link) > a'
		);
	}
	init() {
		$(this.trigger).on('click', this.setNavState);
		$(this.listParent).on('click', this.setListState);
	}
	/**
	 * Creating back button for mobile submenu
	 *
	 * @param {HTMLElement} e - target link
	 */
	cloneLinkOnClick(e) {
		e.preventDefault();
		const linkParent = e.currentTarget.closest(
			'.menu-item:not(.mobile-navigation-link)'
		);
	}

	setNavState(e) {
		const body = $('body');
		if ($(this).hasClass('open')) {
			MobileHeader.hideWrapper(this, body);
		} else {
			MobileHeader.showWrapper(this, body);
		}
	}

	setListState(e) {
		// Only prevent default for menu items that have a mega-menu submenu
		// Allow normal navigation for top-level links without submenus (e.g., Resources, Case Studies)
		const menuItem = e.currentTarget.closest('.menu-item');
		const hasMegaMenu = menuItem?.querySelector('.mega-menu-wrapper');

		if (hasMegaMenu) {
			e.preventDefault();
			if (!$(this).hasClass('open')) {
				$(this).addClass('open');
			} else {
				$(this).removeClass('open');
			}
		}
		// Links without mega-menus will navigate normally
	}
	static hideWrapper(el, body) {
		$(el).removeClass('open');
		body.removeClass('overlayed');
		$(el).parent().next().removeClass('active');
		const subMenuOpen = document.querySelector('.menu a.open');
		const scrollContent = document.querySelector('header .scroll-content');
		subMenuOpen ? subMenuOpen.classList.remove('open') : null;

		if (scrollContent) {
			scrollContent.style.height = '100%';
		}

		megaMenuWrapper.forEach((element) => {
			enableBodyScroll(element);
		});

		enableBodyScroll(scrollContent);
	}

	static showWrapper(el, body) {
		$(el).addClass('open');
		body.addClass('overlayed');
		$(el).parent().next().addClass('active');
		const scrollContent = document.querySelector('header .scroll-content');

		megaMenuWrapper.forEach((element) => {
			disableBodyScroll(element);
		});
		disableBodyScroll(scrollContent);

		MobileHeader.calculateMobileHeight();
	}

	static calculateMobileHeight() {
		const header = document.querySelector('.main-header');
		const alertBar = document.querySelector('.alert-bar');
		const scrollContent = document.querySelector('header .scroll-content');

		if (header && scrollContent) {
			const headerHeight = header.offsetHeight ?? 0;
			const alertBarHeight = alertBar?.offsetHeight ?? 0;
			scrollContent.style.height = `calc(${window.innerHeight}px - ${headerHeight}px - ${alertBarHeight}px)`;
		}
	}

	resized() {
		MobileHeader.calculateMobileHeight();

		if (mediaQueryXl.matches) {
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
	}
	hideOutsideClick(e) {
		if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
			const container = $('.main-header');

			if (
				!container.is(e.target) &&
				container.has(e.target).length === 0
			) {
				MobileHeader.hideWrapper(this.trigger, $(this.pbody));
			}
		}
	}
}

export default MobileHeader;
/* eslint-enable */
